module.exports = __webpack_public_path__ + "static/media/Betty_Lee_Man.a1d2f729.png";